module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "diagramm"
    }
  }, [_c('div', {
    staticClass: "klassenname"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.klasse.name),
      expression: "klasse.name",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "id": "klassennameinput",
      "type": "text"
    },
    domProps: {
      "value": (_vm.klasse.name)
    },
    on: {
      "focus": function($event) {
        _vm.select('class', _vm.klasse.name)
      },
      "change": function($event) {
        _vm.klasse.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "attribute"
  }, [_c('draggable', {
    model: {
      value: (_vm.klasse.fields),
      callback: function($$v) {
        _vm.klasse.fields = $$v
      },
      expression: "klasse.fields"
    }
  }, _vm._l((_vm.klasse.fields), function(attribut) {
    return _c('div', {
      staticClass: "attribut"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "size": "30",
        "placeholder": "attributname: datentyp"
      },
      domProps: {
        "value": (attribut.name ? attribut.name : '') + (attribut.type ? ': ' + attribut.type : '')
      },
      on: {
        "focus": function($event) {
          _vm.select('field', attribut)
        },
        "change": _vm.changeField
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.removeField(attribut)
        }
      }
    }, [_vm._v("✗")]), _vm._v(" "), _c('span', {
      staticClass: "move"
    }, [_vm._v("⇳")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "new",
    on: {
      "click": _vm.createField
    }
  }, [_vm._v("+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "methoden"
  }, [_c('draggable', {
    model: {
      value: (_vm.klasse.methods),
      callback: function($$v) {
        _vm.klasse.methods = $$v
      },
      expression: "klasse.methods"
    }
  }, _vm._l((_vm.klasse.methods), function(methode) {
    return _c('div', {
      staticClass: "methode"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "size": "30",
        "placeholder": "methodenname(param: typ, ...): rueckgabetyp"
      },
      domProps: {
        "value": _vm.methodeAlsUML(methode)
      },
      on: {
        "focus": function($event) {
          _vm.select('method', methode)
        },
        "change": _vm.changeMethod
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.removeMethod(methode)
        }
      }
    }, [_vm._v("✗")]), _vm._v(" "), _c('span', {
      staticClass: "move"
    }, [_vm._v("⇳")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "new",
    on: {
      "click": _vm.createMethod
    }
  }, [_vm._v("+")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da98f512","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Diagramm.vue
// module id = 29
// module chunks = 0